import { StyledProps } from '@emotion/react';
import styled from '@emotion/styled';
import { MouseEventHandler } from 'react';

import Icon from '../icons/icon';

type PropsType = {
    onBack: MouseEventHandler<HTMLElement>;
    onForth: MouseEventHandler<HTMLElement>;
    allowBack: boolean;
    allowForth: boolean;
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    color: ${(props) => props.theme.palette.text.primary};
`;

const IconBox = styled(Icon)<StyledProps<{ active: boolean }>>`
    color: ${(props) =>
        props.active
            ? props.theme.palette.text.primary
            : props.theme.palette.text.disabled};
    display: flex;
    border-radius: ${(props) => props.theme.shape.radius.default};
    margin-inline-start: ${(props) => props.theme.spacing.xxs};
    margin-inline-end: ${(props) => props.theme.spacing.xxs};
    position: relative;
    pointer-events: auto;

    cursor: ${({ active }) => (active ? 'pointer' : 'default')};

    &:hover {
        background: ${(props) =>
            props.active ? props.theme.palette.actions.hover : 'none'};
    }

    & path {
        stroke-width: 70;
    }
`;

const ContentScrollerHeaderNavigation = ({
    onBack,
    onForth,
    allowForth = false,
    allowBack = false,
}: PropsType) => {
    const handleBack: MouseEventHandler<HTMLElement> = (e) => {
        allowBack && onBack(e);
    };
    const handleForth: MouseEventHandler<HTMLElement> = (e) => {
        allowForth && onForth(e);
    };

    return (
        <Container>
            <IconBox
                active={allowBack}
                name='keyboard_arrow_left'
                onClick={handleBack}
                size='medium'
                color='inherit'
            />

            <IconBox
                active={allowForth}
                name='keyboard_arrow_right'
                onClick={handleForth}
                size='medium'
            />
        </Container>
    );
};

export default ContentScrollerHeaderNavigation;
